import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpeakerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"speaker"}/>
}
